import { Schema } from "effect";
import {
  ChannelThreadId,
  SupportTicketId,
  TopicId,
} from "../../../ids/definitions";
import { CustomerBasicInfo } from "../../customer";
import { Message, MessageChannel } from "./message";
import {
  SupportTicketAssigneeType,
  SupportTicketStatus,
} from "./support-ticket";

/** Only non-closed handoff targets are surfaced here. */
export const TextConciergeEscalatedSupportTicket = Schema.Struct({
  id: SupportTicketId,
  status: SupportTicketStatus,
});
export type TextConciergeEscalatedSupportTicket =
  typeof TextConciergeEscalatedSupportTicket.Type;

/** Concierge conversations list row (topic + lane counts/timestamps). */
export const ShopperAgentConversationListItem = Schema.Struct({
  topicId: TopicId,
  channelThreadId: ChannelThreadId,
  channel: MessageChannel,
  customer: Schema.NullOr(CustomerBasicInfo),
  numCustomerMessages: Schema.Number,
  numMerchantMessages: Schema.Number,
  lastCustomerMessageAt: Schema.NullOr(Schema.Date),
  lastMerchantMessageAt: Schema.NullOr(Schema.Date),
  lastCustomerMessageContent: Schema.NullOr(Schema.String),
  escalatedSupportTicket: Schema.NullOr(TextConciergeEscalatedSupportTicket),
  createdAt: Schema.Date,
  updatedAt: Schema.Date,
});
export type ShopperAgentConversationListItem =
  typeof ShopperAgentConversationListItem.Type;

export const ShopperAgentConversationListResponse = Schema.Struct({
  items: Schema.Array(ShopperAgentConversationListItem),
  hasMore: Schema.Boolean,
});
export type ShopperAgentConversationListResponse =
  typeof ShopperAgentConversationListResponse.Type;

export const TextConciergeFilterTab = Schema.Literal(
  "all",
  "awaiting",
  "replied",
  "escalated",
);
export type TextConciergeFilterTab = typeof TextConciergeFilterTab.Type;

/** Detail payload; messages are the shared Message union. */
export const ShopperAgentConversationDetailResponse = Schema.Struct({
  topicId: TopicId,
  channelThreadId: ChannelThreadId,
  channel: MessageChannel,
  customer: Schema.NullOr(CustomerBasicInfo),
  messages: Schema.Array(Message),
  supportTicketId: Schema.NullOr(SupportTicketId),
  assigneeType: Schema.NullOr(SupportTicketAssigneeType),
});
export type ShopperAgentConversationDetailResponse =
  typeof ShopperAgentConversationDetailResponse.Type;
